document.addEventListener('DOMContentLoaded', function() {

  // Add lightgallery to block gallery
  if (typeof lightGallery !== 'undefined') {
    document.querySelectorAll('.wp-block-gallery').forEach(gallery => {
      lightGallery(gallery, {
        selector: '.wp-block-image img', // Selector for gallery items
        thumbnail: true,
        zoom: true,
      });
    });
  }

});